import {useSelector} from 'react-redux'

import Icon from '../../../../../Components/Common/icon'

const getCurrencySymbol = (currencyId, currencies) => {
  const currency = currencies.find(curr => curr.currencyId === currencyId)
  return currency ? currency.symbol : ''
}

const InfoItem = ({iconName, label, value, suffix = '', additionalPrice}) => {
  const currencies = useSelector(state => state.Info.data.currencies)

  return (
    <div className="d-flex gap-3">
      <div>
        <Icon size={[40, 40]} icon={iconName} />
      </div>
      <div className="d-flex flex-column">
        <span className="fs-14 labels-tags heading_5">{label}</span>
        <div>
          <span className="bodyText_1 mt-1">
            {value} {suffix}
          </span>
          {additionalPrice && (
            <>
              <i className="mdi mdi-arrow-right-thin"></i>
              <span className="bodyText_1 mt-1">
                {additionalPrice.baseValue}{' '}
                {getCurrencySymbol(additionalPrice.currencyId, currencies)}
              </span>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default InfoItem
